// extracted by mini-css-extract-plugin
export var actions = "_kg-g";
export var benefitCard = "_kg-b";
export var benefitIcon = "_kg-d";
export var benefitLabel = "_kg-f";
export var benefits = "_kg-a";
export var benefitsSection = "_kg-8";
export var bodyText = "_kg-7";
export var closeButton = "_kg-2";
export var content = "_kg-3";
export var eyebrow = "_kg-4";
export var heading = "_kg-5";
export var image = "_kg-i";
export var imagePanel = "_kg-h";
export var modal = "_kg-0";
export var offerCard = "_kg-c";
export var offerIcon = "_kg-e";
export var sectionLabel = "_kg-9";
export var shell = "_kg-1";
export var title = "_kg-6";